import { useTheme } from "@emotion/react";
import {
  ApartmentOutlined,
  AttachFileOutlined,
  LocalOfferOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  createFilterOptions,
  Divider,
  Grid,
  InputAdornment,
  LinearProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import { forwardRef, useEffect, useState } from "react";
import { IMaskInput } from "react-imask";
import FileDropzone from "../../uploadAnexo/fileDropzone";
import InfoPopover from "../../infoPopover";
import useStyles from "./styles";

import VirtualizedAutocomplete from "../../virtualization/virtualizedAutocomplete";

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={[{ mask: "(00) 0000-0000" }, { mask: "(00) 00000-0000" }]}
      inputRef={ref}
      onAccept={(value, mask) => {
        // 'value' aqui é o número limpo (ex: 11988887777)
        onChange({ target: { name: props.name, value: mask.unmaskedValue } });
      }}
      overwrite
    />
  );
});
export default function EditTicketComponentCliente(params) {
  const {
    loadingServicos = false,
    loadingCreateTicket = false,
    loadingParams = false,
    servicos = [],
    setDataTicket = () => {},
    dataTicket = {},
    error = false,
    tipoAtendimento = [],
    isEdit = false,
    isAddAnexo = false,
    files = [],
    setFiles = () => {},
    setForms = () => {},
    forms = {},
    dataForms = [],
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [dragActive, setDragActive] = useState(false);
  const filter = createFilterOptions();
  useEffect(() => {
    setForms({});
  }, [dataTicket?.tipoAtendimentoId]);
  useEffect(() => {
    const handlePaste = (event) => {
      // Verifica se existe algo na área de transferência
      if (event.clipboardData && event.clipboardData.items) {
        const items = event.clipboardData.items;
        const pastedFiles = [];

        // Itera sobre os itens colados
        for (let i = 0; i < items.length; i++) {
          // Se o item for um arquivo (ex: imagem de print)
          if (items[i].kind === "file") {
            const file = items[i].getAsFile();

            // Renomear o arquivo para evitar nomes genéricos como "image.png"

            if (file) {
              const newFile = new File(
                [file],
                `print_${new Date().getTime()}.png`,
                { type: file.type },
              );
              pastedFiles.push(newFile);
            }
          }
        }

        // Se houver arquivos válidos, adiciona ao state
        if (pastedFiles.length > 0) {
          event.preventDefault(); // Evita comportamento padrão se houver arquivo
          addFiles(pastedFiles);
        }
      }
    };

    // Adiciona o ouvinte no documento inteiro quando o componente monta
    document.addEventListener("paste", handlePaste);

    // Remove o ouvinte quando o componente desmonta
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);

  // Drag & Drop
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };
  const handleDragLeave = () => {
    setDragActive(false);
  };
  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      addFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  };

  const handleFileChange = (event) => {
    addFiles(event.target.files);
  };
  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const addFiles = (novosArquivos) => {
    setFiles((prev) => [...prev, ...Array.from(novosArquivos)]);
  };

  const maskTelefone = (value = "") => {
    const numbers = value.replace(/\D/g, "");

    if (numbers.length <= 10) {
      // Fixo
      return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    }

    // Celular
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
  };

  function formatarNome(nome) {
    if (!nome) return "";

    return nome
      .toLowerCase() // tudo minúsculo
      .replace(/_/g, " ") // troca underscore por espaço
      .replace(/\s+/g, " ") // remove espaços extras
      .trim() // remove espaços no início/fim
      .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase()); // primeira letra de cada palavra maiúscula
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        height: "79%",
        borderRadius: "16px",
        p: 0.8,
        position: "relative",
        overflow: "hidden",
        backgroundColor:
          theme.palette.mode === "dark"
            ? alpha(theme.palette.colors.black.dark, 0.4)
            : theme.palette.colors.black.lighter,
      }}
    >
      <Box sx={styles.paperItens}>
        <Grid
          container
          spacing={2}
          columns={{
            xs: 6,
            sm: 6,
            smx: 6,
            md: 6,
            lg: 6,
            xl: 6,
            xxl: 6,
          }}
        >
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ApartmentOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados cadastrais
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <TextField
              disabled
              variant="filled"
              size="small"
              label="Cliente"
              value={dataTicket?.nome || ""}
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <Autocomplete
                size="small"
                options={servicos}
                disabled={
                  !dataTicket?.cnpj || loadingServicos || loadingCreateTicket
                }
                value={
                  servicos?.find(
                    (servico) =>
                      servico?.id_cliente_servico ===
                      dataTicket?.clienteServicoId,
                  ) || null
                }
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                Referência:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome || ""}`
                    : ""
                }
                onChange={(event, value) => {
                  if (!value) {
                    setDataTicket((prev) => ({
                      ...prev,
                      clienteServicoId: null,
                      telefone: null,
                      email: null,
                      enderecoInstalacao: null,
                    }));
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    clienteServicoId: value?.id_cliente_servico || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Serviço"
                    error={error && !dataTicket?.clienteServicoId}
                    helperText={
                      error &&
                      !dataTicket?.clienteServicoId &&
                      "Campo obrigatório"
                    }
                  />
                )}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
              />

              {loadingServicos && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              variant="filled"
              label="Telefone de contato"
              disabled={
                !dataTicket?.clienteServicoId || loadingCreateTicket || isEdit
              }
              value={maskTelefone(dataTicket?.telefone || "")}
              onChange={(event) => {
                const cellphoneNumber = event.target.value.replace(/\D/g, "");

                setDataTicket((prev) => ({
                  ...prev,
                  telefone: cellphoneNumber,
                }));
              }}
              error={error && !dataTicket?.telefone}
              helperText={error && !dataTicket?.telefone && "Campo obrigatório"}
            />
          </Grid>

          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              value={dataTicket?.email || ""}
              variant="filled"
              label="E-mail"
              disabled={
                !dataTicket?.clienteServicoId || loadingCreateTicket || isEdit
              }
              onChange={(event) => {
                setDataTicket((prev) => ({
                  ...prev,
                  email: event.target.value,
                }));
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              variant="filled"
              label="Endereço de instalação"
              value={dataTicket?.enderecoInstalacao || ""}
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Divider />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalOfferOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados do ticket
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={tipoAtendimento}
                value={
                  tipoAtendimento?.find(
                    (item) => item?.id === dataTicket?.tipoAtendimentoId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.descricao || ""} ` : ""
                }
                disabled={loadingParams || loadingCreateTicket}
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    tipoAtendimentoId: value?.id || null,
                  }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    variant="filled"
                    error={error && !dataTicket?.tipoAtendimentoId}
                    helperText={
                      error &&
                      !dataTicket?.tipoAtendimentoId &&
                      "Campo obrigatório"
                    }
                    {...params}
                    label="Tipo de atendimento"
                  />
                )}
              />
              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>

          {/* --- INÍCIO DOS CAMPOS DINÂMICOS --- */}
          {(() => {
            const atendimentoAtual = dataForms.find(
              (item) =>
                item.tipoAtendimentoId === dataTicket?.tipoAtendimentoId,
            );

            if (!atendimentoAtual || !atendimentoAtual?.forms) return null;

            const totalItems = atendimentoAtual.forms.length;

            return atendimentoAtual.forms.map((dynamicField, idx) => {
              const fieldKey = dynamicField.name;

              // Para todos os outros casos (número par ou itens anteriores do ímpar), ocupa 3 (metade).
              const isTotalOdd = totalItems % 2 !== 0;
              const isLastItem = idx === totalItems - 1;

              const size = isTotalOdd && isLastItem ? 6 : 3;

              return (
                <Grid
                  key={idx}
                  item
                  xs={6} // No mobile (telas muito pequenas) continua um embaixo do outro
                  sm={size} // Aplica o tamanho dinâmico (3 ou 6) para telas maiores
                  smx={size}
                  md={size}
                  lg={size}
                  xl={size}
                  xxl={size}
                >
                  <Box sx={styles.boxTextField}>
                    <TextField
                      sx={{ width: "100%" }}
                      size="small"
                      variant="filled"
                      label={dynamicField?.name || ""}
                      value={forms?.[fieldKey] || ""}
                      onChange={(e) =>
                        setForms((prev) => ({
                          ...prev,
                          [fieldKey]: e.target.value,
                        }))
                      }
                      InputProps={{
                        ...(dynamicField.type === 1
                          ? { inputComponent: TextMaskCustom }
                          : {}),
                        ...(dynamicField?.description
                          ? {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <InfoPopover
                                    titulo={dynamicField?.name}
                                    descricao={dynamicField.description}
                                    iconSize="small"
                                    sxIcon={{ p: 0 }}
                                  />
                                </InputAdornment>
                              ),
                            }
                          : {}),
                      }}
                    />
                  </Box>
                </Grid>
              );
            });
          })()}

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <TextField
              value={dataTicket?.descricaoAbertura || ""}
              onChange={(e) =>
                setDataTicket((prev) => ({
                  ...prev,
                  descricaoAbertura: e.target.value,
                }))
              }
              label="Descrição de abertura"
              variant="filled"
              InputProps={{
                inputComponent: "textarea",
              }}
              /*   disabled={loadingCreateTicket || loadingParams} */
              error={
                error &&
                (!dataTicket?.descricaoAbertura ||
                  dataTicket?.descricaoAbertura.length < 10)
              }
              helperText={
                (error &&
                  !dataTicket?.descricaoAbertura &&
                  "Campo obrigatório") ||
                (error &&
                  dataTicket?.descricaoAbertura?.length > 0 &&
                  dataTicket?.descricaoAbertura.length < 10 &&
                  "A descrição deve ter no mínimo 10 caracteres")
              }
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  paddingTop: "25px",
                  paddingRight: "5px",
                  paddingBottom: "5px",
                },
                "& textarea": {
                  resize: "vertical",
                  minHeight: "80px",
                  padding: "10px 12px",
                },
              }}
            />
          </Grid>
          {isAddAnexo && (
            <>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Divider />
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AttachFileOutlined
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography sx={{ fontWeight: "bold" }}>Anexos</Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Box
                  sx={{
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {isAddAnexo && (
                    <FileDropzone
                      files={files}
                      dragActive={dragActive}
                      setDragActive={setDragActive}
                      inputId="fileInputEditTicket"
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onFileChange={handleFileChange}
                      onRemoveFile={handleRemoveFile}
                    />
                  )}
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Paper>
  );
}
